import { useEffect, useState } from 'react';
import { getPricingById, updatePricing } from '../../services/pricing/editPricingService.js';
import { isNameValid, isPriceValid, isDescriptionValid } from '../../utils/validations/pricingValidations.js';

const initialForm = {
    name: '',
    value: '',
    description: ''
};

export const useEditPricing = (id) => {
    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);

    useEffect(() => {
        const loadPrice = async () => {
            try {
                const price = await getPricingById(id);
                setForm({ ...initialForm, ...price });
            } catch (err) {
                setError(
                    err.response?.status === 404
                        ? 'Precio no encontrado.'
                        : 'Error al obtener los datos del precio.'
                );
            }
        };

        loadPrice();
    }, [id]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const submit = async () => {
        if (!isNameValid(form.name)){
            setError('El nombre del precio solo pueden contener letras.');
            return;
        }
        if (!isPriceValid(form.value)){
            setError('La cantidad solo pueden contener números.');
            return;
        }
        if (!isDescriptionValid(form.description)){
            setError('El campo comentarios no puede contener caracteres especiales.');
            return;
        }
        // Si todo esta validado, procedimiento guardar
        try {
            await updatePricing(id, {
                ...form
            });
            setSuccess('El precio ha sido actualizado exitosamente.');
            setValidationErrors([]);
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.error || 
                err.response?.data?.message || 
                'Error al actualizar el precio.'
            );
        }
    }

    const clearMessages = () => {
        setError('');
        setSuccess('');
        setValidationErrors([]);
    };

    return {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        clearMessages
    };
}